import { Membership } from "./medplum";

export enum Role {
  SuperAdmin = "super-admin",
  Admin = "admin",
  PatientCoordinator = "patient-coordinator",
  Doctor = "doctor",
}

export type MemberRole = Role.Admin | Role.PatientCoordinator | Role.Doctor;

export type TeamMember = {
  practitionerId: string;
  memberId: string | null;
  fullName: string;
  email: string;
  role: MemberRole | null;
  deleted: boolean;
};

export type FullUser = {
  id: string;
  fullName: string;
  email: string;
  projectId: string;
  memberships: Membership[];
};

export type UserAccess = {
  /**
   * Project & clinic config
   */
  canEditProject: boolean;
  canManageClinicConfig: boolean;

  /**
   * Members
   */
  canReadMembers: boolean;
  canWriteMembers: boolean;

  /**
   * Practitioners
   */
  canManageAllPractitioners: boolean;
  canManageOwnPractitioner: boolean;

  /**
   * EHR connections
   */
  canConnectOwnCalendar: boolean;

  /**
   * Schedules / availability
   */
  canManageAllSchedules: boolean;
  canManageOwnSchedule: boolean;

  /**
   * Channels & analytics
   */
  canManageWhatsApp: boolean;
  canViewAnalytics: boolean;
};
